import { render } from "./ChatbotDropdown.vue?vue&type=template&id=183d089a&scoped=true"
import script from "./ChatbotDropdown.vue?vue&type=script&lang=js"
export * from "./ChatbotDropdown.vue?vue&type=script&lang=js"

import "./ChatbotDropdown.vue?vue&type=style&index=0&id=183d089a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183d089a"]])

export default __exports__